// Module
var code = "<h1 id=\"help-desk\">Help Desk</h1> <p>This is the tab where users are added to the help desk chat feature for a campus.</p> <p>Once added they will be able to access the Helpdesk in Operations&gt;Helpdesk.</p> ";
// Exports
module.exports = code;